// extracted by mini-css-extract-plugin
export default {"background":"BackGeneral_background__zTvSh"};